import { useEffect } from "react";

/**
 * Lightweight per-page SEO updater. Sets <title>, meta description,
 * canonical, and OG/Twitter title+description on route mount.
 *
 * Avoids adding react-helmet as a dependency — keeps SEO improvements
 * runtime-only and non-invasive.
 */
const SITE = "https://quantumgenesislabs.com";

const upsertMeta = (selector, attrs) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => {
            if (k !== "content") el.setAttribute(k, v);
        });
        document.head.appendChild(el);
    }
    if (attrs.content !== undefined) el.setAttribute("content", attrs.content);
};

const upsertLink = (rel, href) => {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

export const usePageMeta = ({ title, description, path }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            upsertMeta('meta[name="description"]', { name: "description", content: description });
            upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
            upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
        }
        if (title) {
            upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
            upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
        }
        const url = path ? `${SITE}${path}` : SITE + "/";
        upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
        upsertLink("canonical", url);
    }, [title, description, path]);
};

export default usePageMeta;
